import apiClient from "../services/ApiClient";
import { useEffect, useState } from "react";
import { components } from "../types/OnuoGate";
import {
  Button,
  DatePicker,
  FloatButton,
  Form,
  GetProp,
  InputNumber,
  Modal,
  Space,
  Table,
  TableColumnsType,
  TableProps,
  Tag,
} from "antd";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import EditModal from "../components/EditModal";
import { TableRowSelection } from "antd/es/table/interface";
import { EditFilled } from "@ant-design/icons";
import SelectLogoDevice from "../components/SelectLogoDevice";
import {
  PageContainer,
  ProColumns,
  ProTable,
} from "@ant-design/pro-components";

const { RangePicker } = DatePicker;

interface TableParams {
  pagination?: TablePaginationConfig;
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}

type ColumnsType<T extends object = object> = TableProps<T>["columns"];
type TablePaginationConfig = Exclude<
  GetProp<TableProps, "pagination">,
  boolean
>;

export default function Home(_props: any) {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isShowEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    const { id } = params;

    if (id) {
      setShowEditModal(true);
    } else {
      setShowEditModal(false);
    }
  }, [params]);

  const onCloseEditModal = () => {
    if (state == null) {
      navigate("/orders");
      return;
    }

    navigate(-1);
  };

  const [filteredDates, setFilteredDates] = useState(null);

  const columns: ProColumns<components["schemas"]["OpenOrder"]>[] = [
    {
      title: "IMEI",
      dataIndex: ["openOrderLine", "openOrderLineItem", "imei"],
      hidden: true,
      hideInForm: true,
      hideInSetting: true,
    },
    {
      key: "firmFranchiseCode",
      title: "Bayi Id",
      dataIndex: "firmFranchiseCode",
    },
    {
      key: "orderDate",
      title: "Sipariş Tarihi",
      dataIndex: "orderDate",
      valueType: "dateTimeRange",
      render: (text, record) => {
        return record.orderDate
          ? new Date(record.orderDate).toLocaleString()
          : "";
      },
    },
    /* {
             key: 'status',
             title: 'Sipariş Durumu',
             dataIndex: 'status',
             render: (i, row) => OrderStatus(row.orderStatus || -2),
             filters: [
                 {text: 'Hazırlık', value: 1},
                 {text: 'Onaylı', value: 2},
                 {text: 'Kapalı', value: 3},
                 {text: 'İptal', value: -1},
             ]
         },
         */

    {
      key: "completeStatus",
      title: "Durum",
      render: (i, row) => {
        return <div>test</div>;
      },
    },
    {
      key: "createdAt",
      title: "Oluşturulma Tarihi",
      dataIndex: "createdAt",
      render: (i, row) =>
        row.createdAt ? (
          <Tag>{new Date(row.createdAt).toLocaleString()}</Tag>
        ) : (
          ""
        ),
    },

    {
      title: "Action",
      key: "action",
      fixed: "right",
      search: false,
      render: (_: any, record: components["schemas"]["OpenOrder"]) => (
        <Space size="middle">
          <Link to={"/orders/modal/" + record.id} state={{ from: "home" }}>
            <Button color={"primary"} variant={"solid"}>
              Görüntüle
            </Button>
          </Link>
        </Space>
      ),
    },
  ];
  const [dataSource, setDataSource] = useState<
    components["schemas"]["OpenOrder"][]
  >([]);

  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  /*  useEffect(() => {
          const fetch = async () => {
              const response = await apiClient.getOrders({
                  Page: tableParams.pagination?.current || 1,
                  PageSize: tableParams.pagination?.pageSize || 10,
                  Filter: JSON.stringify(tableParams.filters),
              });
              setDataSource(response.data.data || []);
              setTableParams({
                  ...tableParams,
                  pagination: {
                      current: response.data.page || 1,
                      pageSize: response.data.pageSize || 10,
                      total: response.data.totalData || 0,
                  },
              })
              setLoading(false);
          }
          fetch();
      }, [
          tableParams.pagination?.current,
          tableParams.pagination?.pageSize,
          JSON.stringify(tableParams.filters),
      ]);*/

  const expandColumns: TableColumnsType<
    components["schemas"]["OpenOrderLine"]
  > = [
    {
      key: "deviceCode",
      title: "Device Code",
      dataIndex: "deviceCode",
    },
    {
      key: "mainProductName",
      title: "Main Product Name",
      dataIndex: "mainProductName",
    },
    {
      key: "siparisMiktar",
      title: "Sipariş Miktarı",
      dataIndex: "siparisMiktar",
    },
    {
      key: "sevkMiktar",
      title: "Sevk Miktarı",
      dataIndex: "sevkMiktar",
    },
    {
      key: "bakiyeMiktar",
      title: "Bakiye Miktar",
      dataIndex: "bakiyeMiktar",
    },
  ];

  const expandedRowRender = (row: components["schemas"]["OpenOrder"]) => {
    return (
      <Table<components["schemas"]["OpenOrderLine"]>
        columns={expandColumns}
        dataSource={row.openOrderLines || []}
        pagination={false}
        rowKey={"subrow_" + row.id?.toString() || "0"}
      />
    );
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isBulkModalOpen, setIsBulkModalOpen] = useState<boolean>(false);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection: TableRowSelection<components["schemas"]["OpenOrder"]> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const [bulkSelectedSaleKit, setBulkSelectedSaleKit] = useState<number | null>(
    null,
  );
  const bulkModalSubmit = () => {
    bulkForm.submit();
  };

  const [bulkForm] = Form.useForm();
  const onOkEditModal = () => {
    console.log("here1");
  };
  return (
    <PageContainer title="Vodafone Siparişler">
      <EditModal
        selectedOrderId={params.id}
        isModalOpen={isShowEditModal}
        onOk={onCloseEditModal}
        onCancel={onCloseEditModal}
      />
      <Modal
        open={isBulkModalOpen}
        onCancel={() => setIsBulkModalOpen(false)}
        onOk={bulkModalSubmit}
      >
        <div>
          <Form
            form={bulkForm}
            onFinish={async (
              values: components["schemas"]["SaleKitRequest"],
            ) => {
              selectedRowKeys.map((x) => {
                return apiClient.addSaleKit(
                  {
                    id: Number(x),
                  },
                  {
                    logicalRef: values.logicalRef,
                    orderStock: values.orderStock,
                  },
                );
              });

              setIsBulkModalOpen(false);
            }}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <Form.Item name={"logicalRef"} label={"Satış Kiti"}>
              <SelectLogoDevice />
            </Form.Item>

            <Form.Item label={"Adet"} name={"orderStock"}>
              <InputNumber />
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <ProTable<components["schemas"]["OpenOrder"]>
        //onChange={handleTableChange}

        rowSelection={rowSelection}
        form={{
          layout: "vertical",
          params: {
            test: 1,
          },
          syncToUrl: (values, type) => {
            if (type === "get") {
              if (values.openOrderLine) {
                return {
                  ...values,
                  openOrderLine: JSON.parse(values.openOrderLine),
                };
              }
            }
            return values;
          },
        }}
        request={async (params, sort, filter) => {
          const { current, pageSize, ...otherFields } = params;

          const response = await apiClient.getOrders({
            Page: current || 1,
            PageSize: pageSize || 10,
            Filter: JSON.stringify({ ...otherFields, ...filter }),
          });

          return {
            data: response.data.data || [],
            success: true,
            total: response.data.totalData,
          };
        }}
        expandable={{ expandedRowRender }}
        rowKey={(x) => x.id?.toString() || "0"}
        columns={columns}
      />
      ;
      {selectedRowKeys.length > 0 && (
        <FloatButton
          icon={<EditFilled />}
          type={"primary"}
          onClick={() => setIsBulkModalOpen(true)}
        />
      )}
    </PageContainer>
  );
}
